import { FormOwnerBanner } from "./OwnerBanner/FormOwnerBanner";
import { useShouldDisplayFormOwnerBanner } from "./OwnerBanner/useShouldDisplayFormOwnerBanner";
import { PaymentNotReadyBanner } from "./PaymentNotReadyBanner/PaymentNotReadyBanner";
import { useShouldDisplayPaymentNotReadyBanner } from "./PaymentNotReadyBanner/useShouldDisplayPaymentNotReadyBanner";

import { GetCurrentUserFrontendObject } from "@/common/contexts/types";

interface NotificationBannersProps {
  form: { organization: { id: string } } | null | undefined;
  loggedOrganization: GetCurrentUserFrontendObject["currentOrganization"] | null | undefined;
}

export const NotificationBanners = ({ form, loggedOrganization }: NotificationBannersProps) => {
  const currentOrganization = loggedOrganization;
  const currentOrganizationId = loggedOrganization?.id;

  const shouldDisplayBanner = useShouldDisplayPaymentNotReadyBanner({ currentOrganization, form });
  const { shouldDisplayFormOwnerBanner } = useShouldDisplayFormOwnerBanner({ currentOrganizationId });

  return (
    <>
      {/* We should make sure that the PaymentNotReadyBanner and FormOwnerBanner components are rendered when needed to not break NotificationBannerHeightContext */}
      {shouldDisplayBanner && <PaymentNotReadyBanner />}
      {shouldDisplayFormOwnerBanner && <FormOwnerBanner loggedOrganization={loggedOrganization} />}
    </>
  );
};
